import * as RecnService from '@services/recn-service'
import {loadJavascriptSrc} from './util'

var mode
var microform

export default class Microform {
  constructer() { }

  init(options) {
    mode = options.mode

    return new Promise((resolve, reject) => {
      if (!options.cardNumberDivId) {
        reject('Missing {cardNumberDivId}')
        return
      }
          
      var styles = options.styles || {}
      var inputPlaceholder = options.cardNumberPlaceholder

      RecnService.flexformCaptureContext(mode)
        .then(captureContext => {
          //Parse JWT
          var jwtPayload = JSON.parse(atob(captureContext.split('.')[1]))
          //Extract Context data
          var ctxData = jwtPayload.ctx[0].data

          loadJavascriptSrc(ctxData.clientLibrary, ctxData.clientLibraryIntegrity)
            .then(() => {
              var flex = new window.Flex(captureContext)

              microform = flex.microform('card', { styles: styles })
              var number = microform.createField('number', { placeholder: inputPlaceholder })

              number.load(`#${options.cardNumberDivId}`)

              if (options.onChange !== undefined) {
                number.on('change', (data) => {
                  var cardData = {}

                  cardData.empty = data.empty
                  cardData.valid = data.valid
                  cardData.couldBeValid = data.couldBeValid

                  if (data.card.length === 1) {
                    cardData.paymentType = toNarPaymentType(data.card[0].cybsCardType)

                    cardData.paymentType = cardData.paymentType || data.card[0].brandedName
                  }

                  options.onChange(cardData)
                })
              }

              resolve()
            })
            .catch(error => {
              log.error('Error loading MicroForm script', error)
              reject('Error loading MicroForm script')
            })
          
        })
        .catch(error => {
          log.error('Error getting Flexform Capture Context', error)
          reject('Error getting Flexform Capture Context')
        })
    })
  }

  tokenizeCard(options) {
    return new Promise((resolve, reject) => {
      if (!options.expirationMonth || options.expirationMonth.trim().length === 0) {
        reject('Missing {expirationMonth}')
        return
      }

      if (!options.expirationYear || options.expirationYear.trim().length === 0) {
        reject('Missing {expirationYear}')
        return
      }

      if (!microform) {
        reject('Microform not initialized')
        return
      }

      //Add 0 padding if not already
      options.expirationMonth = options.expirationMonth.length === 1 ? '0' + options.expirationMonth : options.expirationMonth

      microform.createToken(options, (error, token) => {
        if (error) {
          reject(error.details)
        } else {
          resolve({
            cardInfo: parseCardInfo(token),
            token: token
          })
        }
      })
    })
  }
}

/***********************/
/** Private Functions **/
/***********************/

function parseCardInfo(token) {
  try {
    var tokenData = JSON.parse(atob(token.split('.')[1]))
    var cardData = tokenData.content.paymentInformation.card

    return {
      paymentType: toNarPaymentType(cardData.number.detectedCardTypes[0]),
      number: cardData.number.bin + cardData.number.maskedValue.substr(6),
      expirationMonth: cardData.expirationMonth.value,
      expirationYear: cardData.expirationYear.value
    }
  } catch (e) {
    log.error('Error parsing card data', e)
  }
}

function toNarPaymentType(type) {
  switch (type) {
  case '001':
    return 'Visa'
  case '002':
  case '042':
    return 'Master Card'
  case '003':
    return 'American Express'
  case '004':
    return 'Discover'
  }

  return type
}
